export default {
  app: 'majora',
  api_prefix: '/majora-api',
  login_token_key: 'MajoraV3-Token',
  login_user_key: 'MajoraV3-USER',
  doc_path: '/majora-doc/index.html',
  logo_path: '/images/logos/logo.png',
  main_site: 'https://www.baidu.com',
  footer: 'majora-系统框架',
  copyRight: '2023 因体信息公司',
};
